<template>
    <settings-wrapper v-if="canViewCreditQuotas" title="Space settings" section="Instance Credit Quotas">
        <student-quotas />
    </settings-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import { enumsData } from '@/mixins/enums'
import { isAdminRole } from '@/utils'
import SettingsWrapper from '@/components/SettingsWrapper.vue'

const StudentQuotas = () => import('../components/StudentQuotas.vue')

export default {
    name: 'SpaceConfigurationCreditQuotas',
    mixins: [enumsData],
    components: {
        SettingsWrapper,
        StudentQuotas
    },
    async created() {
        if (this.activeOrgId && !this.spacesWithPrimarySnapshots.length) {
            await this.$store.dispatch('orgStore/fetchOrgSpaces', this.activeOrgId)
        }
    },
    computed: {
        ...mapState('orgStore', ['spacesWithPrimarySnapshots']),
        activeOrgId() {
            return this.$route.params.oid
        },
        activeSpaceId() {
            return this.$route.params.sid
        },
        activeSpaceData() {
            if (!this.activeSpaceId) return null
            return this.spacesWithPrimarySnapshots.find(space => space.sid.toString() === this.activeSpaceId.toString()) || null
        },
        canViewCreditQuotas() {
            return (
                isAdminRole(this.activeSpaceData?.space_role) &&
                this.activeSpaceData?.space_type === this.spaceTypes.EDUCATION_SPACE &&
                Boolean(this.activeSpaceData?.beegfs_sync)
            )
        }
    },
    watch: {
        activeSpaceData: {
            immediate: true,
            handler(space) {
                if (!space || this.canViewCreditQuotas) return
                this.$router.replace({
                    name: 'config-space-file-quotas',
                    params: {
                        oid: this.activeOrgId,
                        sid: this.activeSpaceId
                    }
                })
            }
        }
    }
}
</script>
